import { z } from 'zod';

const imageDto = z.object({
  url: z.string().url(),
  alt: z.string().default(''),
});

export const partnerDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  name: z.string().default(''),
  brand_option_id: z.union([z.string(), z.number()]).transform(String).nullable().default(null),
  logo: imageDto.nullable().default(null),
});

export const partnerListDto = z.object({ data: z.array(partnerDto) });

export type PartnerDto = z.infer<typeof partnerDto>;
